import { useState } from 'react';
import { ChevronRight, ChevronDown, Brain } from 'lucide-react';

interface ThinkingBlockProps {
  content: string;
  redacted?: boolean;
}

export function ThinkingBlock({ content, redacted }: ThinkingBlockProps) {
  const [expanded, setExpanded] = useState(false);

  if (redacted) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 mb-2 rounded-md bg-surface-800/50 border border-surface-700 text-text-muted text-xs italic">
        <Brain className="w-3.5 h-3.5 flex-shrink-0" />
        <span>Thinking hidden for safety</span>
      </div>
    );
  }

  return (
    <details
      className="mb-2 rounded-md bg-surface-800/50 border border-surface-700"
      open={expanded}
      onToggle={(e) => setExpanded((e.target as HTMLDetailsElement).open)}
    >
      <summary className="flex items-center gap-1.5 px-3 py-1.5 cursor-pointer text-xs text-text-muted hover:text-text-secondary select-none list-none">
        {expanded ? (
          <ChevronDown className="w-3 h-3 flex-shrink-0" />
        ) : (
          <ChevronRight className="w-3 h-3 flex-shrink-0" />
        )}
        <Brain className="w-3 h-3 flex-shrink-0" />
        <span className="italic">{expanded ? 'Hide thinking' : 'Show thinking'}</span>
      </summary>
      <div className="px-3 pb-2 text-xs text-text-muted italic whitespace-pre-wrap leading-relaxed">
        {content}
      </div>
    </details>
  );
}
